module.exports = __webpack_public_path__ + "static/media/song.cb5ba95.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/song.mp3
// module id = Isg1
// module chunks = 1